import * as fridgesWeight from 'app/mocks/data/machines/all/fridgesWeight'
import * as terminals from 'app/mocks/data/machines/all/terminals'
import * as microwaves from 'app/mocks/data/machines/microwaves/list'
import * as planogramsShort from 'app/mocks/data/machines/planograms/short'

import { MachineRelationShort } from 'app/types/park/machineRelation'

export const machineRelationShort1: MachineRelationShort = {
    id: 1,
    machine: terminals.terminal1,
    distributors: [planogramsShort.planogramShort1],
    lockers: [planogramsShort.planogramShort2, planogramsShort.planogramShort3],
    weighted_fridges: [],
    microwaves: [microwaves.microwave1, microwaves.microwave2],
}

export const machineRelationShort2: MachineRelationShort = {
    id: 2,
    machine: fridgesWeight.fridgeWeight1,
    distributors: [],
    lockers: [],
    weighted_fridges: [planogramsShort.planogramShort4],
    microwaves: [],
}

export const machineRelationShort3: MachineRelationShort = {
    id: 3,
    machine: fridgesWeight.fridgeWeight2,
    distributors: [],
    lockers: [],
    weighted_fridges: [planogramsShort.planogramShort5],
    microwaves: [microwaves.microwave3],
}

export const machineRelationShort4: MachineRelationShort = {
    id: 4,
    machine: terminals.terminal2,
    distributors: [planogramsShort.planogramShort6],
    lockers: [planogramsShort.planogramShort7, planogramsShort.planogramShort8],
    weighted_fridges: [],
    microwaves: [microwaves.microwave4],
}

export const machineRelationShort5: MachineRelationShort = {
    id: 5,
    machine: fridgesWeight.fridgeWeight3,
    distributors: [],
    lockers: [],
    weighted_fridges: [planogramsShort.planogramShort9],
    microwaves: [],
}

export const machineRelationShort6: MachineRelationShort = {
    id: 6,
    machine: terminals.terminal3,
    distributors: [],
    lockers: [planogramsShort.planogramShort10],
    weighted_fridges: [],
    microwaves: [],
}
